"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENABLED_GAME_MODES = exports.GAME_MODES = void 0;
exports.isValidGameModeId = isValidGameModeId;
exports.getGameMode = getGameMode;
exports.calculateMoveTimeout = calculateMoveTimeout;
/**
 * Registry of all game modes
 */
exports.GAME_MODES = {
    standard: {
        id: "standard",
        displayName: "Standard",
        perMoveTimeLimit: 60000, // 60 seconds (from Constants.TURN_TIMEOUT_MS)
        totalTimeLimit: 0, // No time bank
        bronstein: 0, // No free time
        animation: {
            checkerMinDuration: 200, // From ANIMATION_CONFIG.MIN_DURATION
            checkerMaxDuration: 600, // From ANIMATION_CONFIG.MAX_DURATION
            checkerBaseSpeed: 400, // From ANIMATION_CONFIG.BASE_SPEED
            turnTransitionDuration: 200, // From ANIMATIONS.TURN_TRANSITION_DURATION
            diceRollDurationMultiplier: 1.0 // Normal dice roll speed
        },
        doublingEnabled: true
    },
    speedgammon: {
        id: "speedgammon",
        displayName: "Speedgammon",
        perMoveTimeLimit: 0, // No per-move limit, using time bank instead
        totalTimeLimit: 120000, // 2-minute time bank (120 seconds)
        bronstein: 10000, // 10-second Bronstein delay
        animation: {
            checkerMinDuration: 50, // Near-instant checker snaps
            checkerMaxDuration: 100, // Cap at 100ms maximum
            checkerBaseSpeed: 2000, // Very fast base speed for instant feel
            turnTransitionDuration: 0, // No delay between turns
            diceRollDurationMultiplier: 0.1 // Near-instant dice (10% of normal 3-4 second roll)
        },
        doublingEnabled: true
    }
};
/**
 * List of enabled game modes (controls what's available in production)
 */
exports.ENABLED_GAME_MODES = ["standard", "speedgammon"];
/**
 * Type guard to check if a string is a valid GameModeId
 */
function isValidGameModeId(id) {
    return id in exports.GAME_MODES;
}
/**
 * Get a game mode configuration by ID
 * @param id - Game mode identifier (validated at runtime for API compatibility)
 * @throws {Error} If the game mode is not found
 */
function getGameMode(id) {
    if (!isValidGameModeId(id)) {
        throw new Error("Invalid game mode");
    }
    return exports.GAME_MODES[id];
}
/**
 * Calculate the timeout for a move based on game mode and player state
 * @param mode - The game mode configuration
 * @param remainingTimeBank - Player's remaining time bank in ms (only used for modes with time banks)
 * @returns Timeout in milliseconds for the current move
 */
function calculateMoveTimeout(mode, remainingTimeBank) {
    if (remainingTimeBank === void 0) { remainingTimeBank = 0; }
    // For modes without time banks (like Standard), use per-move timeout
    if (mode.totalTimeLimit === 0) {
        return mode.perMoveTimeLimit;
    }
    // For time bank modes (like Speedgammon), use Bronstein delay + remaining time
    // Bronstein delay gives free time before time bank starts depleting
    return mode.bronstein + remainingTimeBank;
}
//# sourceMappingURL=game-modes.js.map